export const CONSULTANCY = 1;
export const METEREOLOGY = 0;
export type ContractType = typeof CONSULTANCY | typeof METEREOLOGY;
